module.exports = __webpack_public_path__ + "img/home_off.24403c86.svg";